<template>
	 <v-container style="padding: 0;">
		 <v-sheet class="d-flex">
			 <div style="width: 260px; background-repeat: repeat;">
				<ImgCutter v-on:cutDown="cutDown" :boxWidth="boxWidth" :boxHeight="boxHeight" :cutWidth="cutWidth" :cutHeight="cutHeight" :rate="rate" 
					:tool="false" :moveAble="true" :WatermarkText="waterText" :lockScroll="false" :DoNotDisplayCopyright="true">
				    <template #open>
					   <v-text-field prepend-icon="mdi-camera" placeholder="选择图片" :label="title" v-model="upload.fileName" dense outlined></v-text-field>
				    </template>
				</ImgCutter>
			 </div>
			<!-- <div class="pl-2">
				 <v-progress-circular v-if="upload.percent > 0 " color="success" size="40" width="2"
				 	v-model="upload.percent">
				 	{{ upload.percent }}%
				 </v-progress-circular>
			 </div> -->
			 <div class="ml-2 mt-n1">
				<v-avatar rounded v-if="viewPrevImage && upload.key">
					<v-img :src="imgPrev + upload.key + imgSize50" width="50" height="50"></v-img>
				</v-avatar>
			</div>
		 </v-sheet>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	import global from "../config/global"
	import * as qiniu from 'qiniu-js'
	import storage from "../config/storage"
	import ImgCutter from 'vue-img-cutter'
	export default {
		name:"upload-photo",
		components:{ImgCutter},
		props: {
			show:{
				type:Boolean,
				default:false
			},
			title:{
				type:String,
				default:"上传图片"
			},
			previewImg:{
				type:String,
				default:""
			},
			waterText:{
				type:String,
				default:"有课丫"
			},
			rate:{
				type:String,
				default:"1:1"
			},
			viewPrevImage:{
				type:Boolean,
				default:true
			},
			cutWidth:{
				type:Number,
				default:300
			},
			cutHeight:{
				type:Number,
				default:300
			},
			boxWidth:{
				type:Number,
				default:600
			},
			boxHeight:{
				type:Number,
				default:400
			}
		},
		watch:{
			show(newVal,oldVal){
				console.log("upload photo show=",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					// 先清空
					this.clearUpload();
					
				}
			},
			previewImg(newVal,oldVal){
				if(this.newVal != oldVal){
					console.log("previewImg",newVal);
					this.upload.key = newVal;
				}
			}
		},
		data(){
			return {
				imgPrev:global.config.imgPre,
				imgSize50:global.config.imgSize50,
				hideShow:this.show,
				uploadInProgress:false,
				upload: {
					fileName:"",
					pre: "assets/img/",
					percent: 0,
					key: "" // 全路径
				},
				// 上传的监视事件
				observe: {
					next: this.onNext,
					error: this.onError,
					complete: this.onComplete
				},
			}
		},
		mounted() {
			console.log("upload photo mounted");
			if(this.previewImg){
				this.upload.key = this.previewImg;
			}
		},
		methods:{
			cutDown(event){
				console.log(event);
				this.upload.fileName = event.fileName;
				const file = event.file;
				this.uploadFile(file);
			},
			clearUpload() {
				this.upload.fileName = "";
				this.upload.key = "";
				this.upload.percent = 0;
			},
			onNext(res) {
				this.upload.percent = res.total.percent.toFixed();
			},
			onComplete(res) {
				this.uploadInProgress = false;
				this.$emit("uploading",false);
				console.log("上传图片成功:",res);
				// 上传完成 显示缩略图
				this.upload.key = res.key;
				this.$emit("success",res);
			},
			onError(err) {
				this.uploadInProgress = false;
				this.$emit("uploading",false);
				this.$noty.error("上传失败：" + err.message);
			},
			uploadFile(file) {
				const that = this;
				if (this.uploadInProgress) { this.$noty.error("请等待当前图片上传完成"); return; }
			
				if (file) {
					const indexOfSuffix = file.name.lastIndexOf(".");
					//文件后缀
					const suffix = indexOfSuffix >= 0 ? file.name.substr(indexOfSuffix) : "";
					// 上传的文件名
					const filename = utils.uuid() + suffix;
					// 上传的key
					const key = this.upload.pre  + filename;
				
			
					let uploadToken = storage.getUploadImgToken();
					if (!uploadToken) {
						this.$noty.error("上传失败,上传凭证已失效，请联系管理员");
						return;
					}
					
					// 请求上传的token 然后上传到七牛
					const putExtra = {
						fname: "",
						params: {},
						mimeType: null
					};
					const config = {
						useCdnDomain: true,
						region: qiniu["region"].z2
					};
					this.uploadInProgress = true;
					this.$emit("uploading",true);
					try {
						let observable = qiniu["upload"](file, key, uploadToken, putExtra, config);
						observable.subscribe(this.observe);
					} catch (err) { this.onError(err); }
				}
			},
		}
	}
	
</script>

<style>
</style>
